import React from 'react';
import Button from '../../Button';
import FontAwesomeIcon from '../../Icon';
import File from '../../File';
import { SortIcon } from './SortIcon';
import TextEditor from '../../Editor/Editor';
import { onCheckDocument } from '../../../helpers/CommonHelpers';


export const AddOffers = ({ offers, data, onAddOffer, onSetOffer, onSetEditOffer, handleOfferDelete, onEditorOfferChange, onSortingOffers, onClearFormData }) => {
        let validation = data.offerName && data.offerName.trim() && data.offerLink && data.offerLink.trim() && data.offerLable && data.offerLable.trim() && data.selectedOfferImage.length > 0;
        let isIdsAvailable = offers && offers.length > 0 ? offers.filter(cl => cl.id) : []

        return (
        <div className='input_box'>
            {offers && offers.length > 0 ?
                    offers.filter(q => !q.isdeleted).
                        map((offer, index) => {                            
                            return (
            <div className='offercard mt-15 mb-15'
                draggable={isIdsAvailable && isIdsAvailable.length === 0 || offer.id ? true : false}
                onDragStart={() => onSortingOffers(offer, index, 'start')}
                onDrop={() => onSortingOffers(offer, index, 'drop')}
                onDragOver={ (e) => { e.stopPropagation(); e.preventDefault();
                }}
            >
               <div className='mb-25'>
               {isIdsAvailable && isIdsAvailable.length === 0 || offer.id ? <SortIcon /> : null}
                <div className='deleteIcon' style={{ textAlign: 'right', cursor: 'pointer', float: 'right' }}
                  onClick={() => window.confirm(`Are you sure you want to delete offer?`) && handleOfferDelete(offer)}
                >
                    <FontAwesomeIcon
                        glyph="trash"
                        weight="light"
                        size="small"
                    />
                    Delete Offer
                </div>
                   </div>  
                <div className='offerForm'>
                    <div className='uploadLogo'>
                    <File
                        label=""
                        onSelect={(file) => onCheckDocument(file) && onSetEditOffer(file, 'logo', index)}
                        files={offer && offer.image ? [] : offer && offer.logo && offer.logo.length > 0 ? offer.logo : []}
                        image={ offer && offer.image ? offer.image : null}
                        errors={''}
                        type='image'
                        imageType='image'
                    />
                    </div>
                    <div className='offerinputs'>
                        <div class="w-100 mt-10">
                            <div class='mt-10 offerlable'>Name:<span className='input__required'/> </div>
                            <div class='inputFormoffer'>
                                <input class="form-control" type="text" placeholder="Name" aria-label="default input example"
                                 value={offer.name}
                                 onChange={e => onSetEditOffer(e.target.value, 'name', index)}
                                 required
                                />
                            </div>
                        </div>
                        <div class="w-100 offerDescriptionW">
                            <div class='mt-10 offerlable'>Description:<span className='input__required'/> </div>
                            <div class='inputFormoffer'>
                                {/* <input class="form-control" type="text" placeholder="Description" aria-label="default input example"
                                 value={offer.description}
                                 onChange={e => onSetEditOffer(e.target.value, 'description', index)}
                                 required
                                /> */}
                                {/* <TextEditor 
                                    description={offer.description}
                                    onChange={e => onSetEditOffer(e.target.value, 'description', index)}
                                    placeholder='Description'
                                /> */}
                            <div class style={{ border: '0.1rem solid rgba(83, 83, 83, 0.25)', borderRadius:'5px', padding:'0px', marginBottom: 25 }} className="input__control">
                            <TextEditor 
                                editorState={offer.description}
                                onEditorStateChange={editorState => onSetEditOffer(editorState, 'description', index)}
                                placeholder={'Description'}
                            />
                            </div>
                            </div>
                        </div>
                        <div class="w-100">
                            <div class='mt-10 offerlable'>Link Label:<span className='input__required'/> </div>
                            <div class='inputFormoffer'>
                                <input class="form-control" type="text" placeholder="Link label" aria-label="default input example" 
                                 value={offer.linkURL}
                                 onChange={e => onSetEditOffer(e.target.value, 'linkURL', index)}
                                 required
                                />
                            </div>
                        </div>
                        <div class="w-100">
                            <div class='mt-10 offerlable'>Link:<span className='input__required'/> </div>
                            <div class='inputFormoffer'>
                                <input class="form-control" type="text" placeholder="Link" aria-label="default input example" 
                                 value={offer.linkName}
                                 onChange={e => onSetEditOffer(e.target.value, 'linkName', index)}
                                 required
                                />
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
             )
            }) : null}
            <div className='offercard mt-15 mb-15'>
            {data.offerName || data.offerLink !== 'https://' || data.offerLable || data.selectedOfferImage.length === 1 ?
                    <a onClick={() => onClearFormData('offer')} className='clearLink deleteIcon' style={{ textAlign: 'right', cursor: 'pointer', float: 'right' }}> Clear </a> : null}

                <div className='offerForm'>
                    <div className='uploadLogo'>
                    <File
                        label=""
                        onSelect={(file) => onCheckDocument(file) && onSetOffer(file, 'selectedOfferImage')}
                        files={ data.selectedOfferImage ? data.selectedOfferImage : []}
                        image={ null}
                        errors={''}
                        type='image'
                        imageType='image'
                    />
                 {data.selectedOfferImage && data.selectedOfferImage.length > 0 ? null : <div style={{color: 'red', textAlign : 'center', fontSize: '14px'}}>Image is required</div> }
                    </div>
                    <div className='offerinputs'>
                        <div class="w-100 mt-10">
                            <div class='mt-10 offerlable'>Name:<span className='input__required'/> </div>
                            <div class='inputFormoffer'>
                                <input class="form-control" type="text" placeholder="Name" aria-label="default input example"
                                value={data.offerName}
                                onChange={e => onSetOffer(e.target.value, 'offerName')}
                                required
                                />
                            </div>
                            <div className="input__errors">
                        {data.offerValidation && <div className="input__error">{data.offerValidation}</div>}
                    </div>  

                        </div>
                        <div class="w-100 offerDescriptionW">
                            <div class='mt-10 offerlable'>Description:<span className='input__required'/> </div>
                            <div class='inputFormoffer'>
                                {/* <input class="form-control" type="text" placeholder="Discription" aria-label="default input example"
                                 value={data.offerDescription}
                                 onChange={e => onSetOffer(e.target.value, 'offerDescription')}
                                 required
                                /> */}
                                {/* <TextEditor 
                                    description={data.offerDescription}
                                    onEditorChange={(editorState) => onSetOffer(editorState, 'offerDescription')}
                                    placeholder='Description'
                                /> */}
                                <div class style={{ border: '0.1rem solid rgba(83, 83, 83, 0.25)', borderRadius:'5px', padding:'0px',  marginBottom: 25 }} className="input__control">
                                <TextEditor 
                                editorState={data.offerDescription}
                                onEditorStateChange={onEditorOfferChange}
                                placeholder={'Description'}
                                />
                                </div>
                            </div>
                        </div>
                        <div class="w-100">
                            <div class='mt-10 offerlable'>Link Label:<span className='input__required'/> </div>
                            <div class='inputFormoffer'>
                                <input class="form-control" type="text" placeholder="Link label" aria-label="default input example" 
                                 value={data.offerLable}
                                 onChange={e => onSetOffer(e.target.value, 'offerLable')}
                                 required
                                />
                            </div>
                        </div>
                        <div class="w-100">
                            <div class='mt-10 offerlable'>Link:<span className='input__required'/> </div>
                            <div class='inputFormoffer'>
                                <input class="form-control" type="text" placeholder="Link" aria-label="default input example"
                                 value={data.offerLink}
                                 onChange={e => onSetOffer(e.target.value, 'offerLink')}
                                 required
                                />
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <Button
                color="teal"
                size="small"
                label="+ Add New Offer"
                disabled={!validation}
                onClick={onAddOffer}
            />
        </div>
    )
}